import { InMemoryCacheConfig } from '@apollo/client';

import { ClientSetup, graphqlClient } from '@topconagriculture/graphql-client';

import { API_CLIENTS } from '../../config/constants';
import { config } from '../../config';

const gqlInstance: ClientSetup = graphqlClient;

const cache: InMemoryCacheConfig = {
  typePolicies: {
    AppType: {
      keyFields: false,
    },
  },
};

gqlInstance.setUpClients([
  {
    name: API_CLIENTS.graphqlClient,
    url: config.GRAPHLQ_CLIENT_BASE_URL,
    wsUrl: config.FLEET_GRAPHQL_WSS_CLIENT_BASE_URL,
    memoryCacheConfig: cache,
  },
]);

export default gqlInstance;
